import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { SORTING_ORDER } from '../../../../constants/index';
import moment from 'moment';
import { fetchDonationItemList, fetchDonationsLists } from '../actions/action';
import { Table, Row, Col, Spinner, Badge } from 'reactstrap';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import DonationDetailsDrawer, { RemarksHistoryOffcanvasPortal } from './DonationDetailsDrawer';
import DHPagination from '../../../../components/Pagination';
import FilterSearchQueue from '../../../../components/FilterSearch/FilterSearchQueue';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import './DonationList.css';

const ManageDonationsList = (props) => {
  // Remarks history offcanvas state
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyItem, setHistoryItem] = useState(null);

  // Lightbox state
  const [isLightBoxOpen, setLightBoxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [images, setImages] = useState([]);

  const handleShowImage = (image) => {
    if (Array.isArray(image)) {
      setImages(image);
    } else {
      setImages([image]);
    }
    setPhotoIndex(0);
    setLightBoxOpen(true);
  };

  const handleShowHistory = (item) => {
    setHistoryItem(item);
    setHistoryData(item.remarks_history || []);
    setHistoryOpen(true);
  };
  const handleCloseHistory = () => {
    setHistoryOpen(false);
    setHistoryItem(null);
    setHistoryData([]);
  };
  const { stores, refreshList } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: 'created_at',
    order: SORTING_ORDER.ASC,
  });
  const { country = [] } = useSelector((state) => state.country);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });

  const [store, setStore] = useState('');
  const [storeType, setStoreType] = useState('all');
  const fetchDonationsList = useCallback(async (data) => {
    try {
      setDataLoading(true);
      await fetchDonationsLists({
        params: data,
        dispatch,
      });
    } catch (error) {
      setDataLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDataLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchDonationsList({
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchFilter?.search,
        status: statusFilter?.status === 'All' ? '' : statusFilter?.status,
        advancedFilter,
        country: currentCountry,
        stores,
      });
    }, 300);
    return () => clearTimeout(delay);
  }, [
    paginationValue.page,
    limitValue.limit,
    advancedFilter,
    searchFilter,
    statusFilter,
    stores,
    refreshList, // <-- add this dependency
  ]);

  const { donationsList = [], isLoading } = useSelector(
    (state) => state.donations,
  );

  const [isDataLoading, setDataLoading] = useState(false);
  const [isDrawerLoading, setDrawerLoading] = useState(false);
  const { listOrders } = donationsList;
  const donationData = listOrders?.data;

  let UserRoleID = '';
  let UserCountry = '';

  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
    }
  }

  let pageIndex =
    Number(donationData?.length) > 0
      ? Number(paginationValue.page * limitValue.limit)
      : 0;

  const [viewMode, setViewMode] = useState(false);

  // Drawer state for donation details
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDonationItemData, setSelectedDonationItemData] = useState(null);
  const [currentStatus, setCurrentStatus] = useState('');
  const [statusOptions] = useState([
    { value: '', label: 'Select Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
  ]);

  const fetchDonationItemsList = useCallback(async (data) => {
    try {
      setDrawerLoading(true);
      const response = await fetchDonationItemList({
        params: data,
        dispatch,
      });
      // response.data is the array, response.status etc. may exist
      setSelectedDonationItemData(response);
      setDrawerOpen(true);
    } catch (error) {
      setDrawerLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDrawerLoading(false);
    }
  }, [dispatch]);

  const handleOpenDrawer = (donationId, status) => {
    setCurrentStatus(status);
    fetchDonationItemsList({
      donation_id: donationId,
    });
    
  };
  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedDonationItemData(null);
  };


  return (
    <div className="donation-list-container">
      <Row>
        <Col xl={12}>
          <FilterSearchQueue
            type={'donations'}
            setAdvancedFilter={setAdvancedFilter}
            setSearchFilter={setSearchFilter}
            setStatusFilter={setStatusFilter}
          />
          <div className=" dt-table">
            <div className="table-responsive">
              <Table className="OrderListTable table mb-0">
                <thead>
                  <tr>
                    <th>SI.No</th>
                    <th nowrap="nowrap">Created At</th>
                    <th nowrap="nowrap">Donation ID</th>
                    <th nowrap="nowrap">Customer Name</th>
                    <th nowrap="nowrap">Customer Email</th>
                    <th nowrap="nowrap">Customer Mobile</th>
                    <th nowrap="nowrap">SO Number</th>
                    <th nowrap="nowrap">Declaration</th>
                    <th nowrap="nowrap">Status</th>
                    <th nowrap="nowrap">Action</th>
                  </tr>
                </thead>
                {isLoading || isDataLoading ? (
                  <>
                    <Spinner className="ms-2 sploader" color="primary" />
                    <tbody>
                      {[...Array(2)].map((_, index) => (
                        <tr key={`skeleton-${index}`}>
                          <td>
                            <p className="placeholder-glow">
                              <span className="placeholder col-2"></span>
                            </p>
                          </td>
                          <td>
                            <p className="placeholder-glow">
                              <span className="placeholder col-12"></span>
                              <span className="placeholder col-6"></span>
                              <span
                                className="placeholder"
                                style={{ width: '25%' }}
                              ></span>
                              <span className="placeholder w-75"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow d-flex flex-column gap-1">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className="placeholder-glow">
                              <span className="placeholder col-6"></span>
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </>
                ) : donationData?.length > 0 ? (
                  <>
                    {(donationData || []).map((donation, index) => {
                      pageIndex++;
                      let cdate = donation.created_at,
                        orderDt = moment(new Date(cdate)).format(
                          'Do MMM, YYYY',
                        ),
                        orderTime = moment(new Date(cdate)).format(
                          'h:mm:ss a',
                        );
                      return (
                        <tbody key={donation?.donation_id || index}>
                          <tr>
                            <th scope="row">{pageIndex}</th>
                            <td>
                              <span className="fs-12">{orderDt}</span>
                              <p className="fs-12">{orderTime}</p>
                            </td>
                            <td className="ReturnInfo1">
                              <span className="fs-12">
                                {donation?.donation_id}
                              </span>
                            </td>

                            <td>
                              <span className="fs-12">
                                {donation?.customer_name}
                              </span>
                            </td>
                            <td>{donation?.customer_email || '-'}</td>
                            <td>{donation?.customer_mobile || '-'}</td>
                            <td>{donation?.so_number || '-'}</td>
                            <td>
                              <Badge
                                className={`badge badge-pill text-capitalize text-dark ${
                                  donation?.declaration ===
                                  'true'
                                    ? 'bg-success'
                                    : 'bg-warning'
                                }`}
                              >
                                {donation?.declaration === 'true'
                                  ? 'Declared'
                                  : 'Not Declared'}
                              </Badge>
                            </td>
                            <td>
                              <Badge
                                className={`badge badge-pill text-capitalize text-dark ${
                                  donation?.status.toLowerCase() ===
                                  'pending'
                                    ? 'bg-soft-info'
                                    : donation?.status.toLowerCase() ===
                                        'canceled'
                                      ? 'bg-soft-danger'
                                      :  donation?.status.toLowerCase() ===
                                            'refurbished' || donation?.status.toLowerCase() ===
                                          'ready_for_delivery'
                                        ? 'bg-soft-info'
                                        : donation?.status.toLowerCase() ===
                                            'delivered'
                                          ? 'bg-soft-success'
                                          : donation?.status.toLowerCase() ===
                                              'received' || donation?.status.toLowerCase() ===
                                            'pending_for_refurbishment'
                                            ? 'bg-soft-warning'
                                            : 'bg-soft-light'
                                }`}
                              >
                                {donation?.status}
                              </Badge>
                            </td>
                            <td>
                              <div className="donation-list-action-flex-container">
                                <span
                                  className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                  title="View Donation Info"
                                  onClick={() => handleOpenDrawer(donation?.donation_id, donation?.status)}
                                >
                                  <i className="mdi mdi-eye-outline"></i>
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <tbody>
                      <tr>
                        <td colSpan={10}>No Records found</td>
                      </tr>
                    </tbody>
                  </>
                )}
              </Table>
            </div>
            {donationData?.length > 0 ? (
              <DHPagination
                totalPages={listOrders?.recordsTotal}
                currentPage={paginationValue.page}
                setPaginationValue={setPaginationValue}
                setLimitValue={setLimitValue}
              />
            ) : null}
          </div>
        </Col>
      </Row>
      <ReactDrawer
        open={drawerOpen}
        position="right"
        onClose={handleCloseDrawer}
        style={{ width: '90%' }}
      >
        <DonationDetailsDrawer
          open={drawerOpen}
          onClose={handleCloseDrawer}
          donation={selectedDonationItemData}
          currentStatus={currentStatus}
          onShowHistory={handleShowHistory}
          onShowImage={handleShowImage}
          refreshData={fetchDonationItemsList}
        />
      </ReactDrawer>
      <RemarksHistoryOffcanvasPortal
        isOpen={historyOpen}
        toggle={handleCloseHistory}
        item={historyItem}
        data={historyData}
      />
      {isLightBoxOpen && (
        <Lightbox
          wrapperClassName="lightbox-on-top donation-list-lightbox"
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setLightBoxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}
    </div>
  );
};

export default ManageDonationsList;
